export default __webpack_public_path__ + "static/media/rappi.41f19840.png";